export default function ThankyouPage() {
  return (
    <div className="thankyou-container">
      <div className="thankyou-content">
        <h2>Thank You!</h2>
        <p>Your submission has been received. We will contact you soon.</p>
        <img
          src="https://cdn-icons-png.flaticon.com/512/190/190411.png" 
          alt="Thank You"
          className="thankyou-icon"
        />
      </div>
    </div>
  );
}
